import { select, call, put, delay, fork, take, takeLatest, cancelled, cancel } from "redux-saga/effects";
import {
  fetchExploreShapesData, setExploreShapesData, setExploreShapesIsLoading, setExploreShapesRequestedGeoType,
  selectExploreMapPin, setExploreSelectedShapeId, setExploreSelectedIds, cancelExploreDataFetch, updateExploreShapesDataObjectById, appNotify
} from 'store/actions';
import { shapesDataParamsSelector  } from "store/selectors";
import { mapDataToShapes } from "api/rex/mapShapes";
import { convertZoomToShapesAutoGeoType, getManualShapesGeoTypesForZoomLevel } from "api/rex/spatial";
import { postWithToken } from 'api/network';
import { takeLatestByObjectId } from 'sagas/explorePropertyDataSaga';

async function getMarkets(geoType, bounds, zoom) {
  // REVUE API
  const requestDto = {
    zoomLevel: zoom,
    clusterType: geoType,
    bounds
  }
  const url = `/api/explore/GetMarkets`;
  const response = await postWithToken(url, requestDto);

  // REX API
  // console.log('getMarkets', { groupLevel, bounds, zoom });
  // const url = `/api/ui/GetMarkets?ZoomLevel=${zoom}&ClusterType=${groupLevel}&Bounds=${bounds}`;
  // const response = await getWithToken(url, true); // temp 5/7: pass true to call REX api
  //

  const data = await response.json();
  return data;
}

function* fetchUpdatedData(objectId) {
  try {
    const { bounds, zoom, requestedGeoType, isErrored } = yield select(shapesDataParamsSelector, objectId);
    // if (requestedGeoType) {
      // yield put(setExploreIsLoading(true, "SHAPES", "Loading Shapes Data..."));
      yield put(setExploreShapesIsLoading(objectId, true));
      if (isErrored) {
        yield put(updateExploreShapesDataObjectById(objectId, { isErrored: false }));
      }
      let convertedRequestType;
      if (requestedGeoType === 'auto') {
        convertedRequestType = convertZoomToShapesAutoGeoType(zoom);
      } else {
        console.log(getManualShapesGeoTypesForZoomLevel(zoom))
        console.log(getManualShapesGeoTypesForZoomLevel(zoom).find(type => type.value === requestedGeoType)?.enabled)
        console.log(requestedGeoType)
        if (getManualShapesGeoTypesForZoomLevel(zoom).find(type => type.value === requestedGeoType)?.enabled) { // Use user selected type if it is allowed for current zoom level
          convertedRequestType = requestedGeoType;
        } else {
          yield put(appNotify('Geographic Data - zoom exceeded for selected geo type, switching to auto', 'info'));
          yield put(setExploreShapesRequestedGeoType(objectId, 'auto')); // Else revert to auto mode if zoom no longer fits
          return;
        }
      }
      const shapesData = yield call(getMarkets, convertedRequestType, bounds, zoom);
      const mapped = yield call(mapDataToShapes, shapesData);
      yield put(setExploreShapesData(objectId, mapped, convertedRequestType ));
      // const shapes = yield call(mapDataToShapes, shapesData);
      // yield put(setExploreShapes(shapes));
      // yield put(setExploreIsLoading(false, "SHAPES"));
      yield put(setExploreShapesIsLoading(objectId, false));
    // } else {
    //   const shapesData = [];
    //   const geoType = null;
    //   yield put(setExploreShapesData({ shapesData, geoType }));
    //   const shapes = yield call(mapDataToShapes, shapesData);
    //   yield put(setExploreShapes(shapes));
    // }
  } catch (error) {
    console.log(error);
    // yield put(setExploreIsLoading(false, "SHAPES"));
    yield put(setExploreShapesIsLoading(objectId, false));
    yield put(updateExploreShapesDataObjectById(objectId, { isErrored: true }));
  } finally {
    if (yield cancelled()) {
      // yield put(setExploreIsLoading(false, "SHAPES"));
      yield put(setExploreShapesIsLoading(objectId, false));
    }
  }

}

function* selectMatchingShape({ payload }) {
  if (!payload) return;
  const selectedPinId = payload.clusterID ?? (payload.ids?.length ? payload.ids.slice(-1)[0] : null); // Handling for 'id' from selectExploreMapPin or 'ids' from setExploreSelectedIds (get last element)
  if (!payload.shouldSelectShape || !selectedPinId) return;
  // const groupLevel = yield select(state => state.exploreData.groupLevel);
  // const { geoType } = yield select(state => state.exploreShapesData);
  // const { shapes } = yield select(state => state.exploreMap);
  // if (!groupLevel || !geoType || !shapes) return;
  const { shapesDataObjects } = yield select(state => state.exploreShapesData);
  if (!Object.keys(shapesDataObjects).length) return;

  let foundShape = null;
  const foundObjectId = Object.keys(shapesDataObjects).find(objectId => {
    const sdo = shapesDataObjects[objectId];
    if (!sdo.isVisible) return false;
    const shape = sdo.shapesData.find(el => {
      return selectedPinId === el.id || selectedPinId === el.GeoName; 
    });
    if (shape) {
      foundShape = shape;
    }
    return shape;
  })
  console.log(foundObjectId, foundShape)
  // const foundShape = shapes.find(shape => {
  //   return selectedPinId === shape.id || selectedPinId === shape.GeoName;
  // });

  if (foundShape) { // Select shape if found, else deselect shapes
    yield put(setExploreSelectedShapeId(parseInt(foundObjectId) || foundObjectId, foundShape.id)); 
  } else {
    yield put(setExploreSelectedShapeId(null, null)); 
  }
  // yield put(setExploreSelectedShapeId(foundShape?.id ?? null)); 
}

export function* exploreShapesDataSaga() {
  // yield takeLatestByObjectId(setExploreShapesRequestedGeoType, ({ payload }) => fetchUpdatedData(payload.objectId));
  yield takeLatestByObjectId([fetchExploreShapesData, setExploreShapesRequestedGeoType], function* ({ payload }) {
    yield delay(100); // Delay to allow 'finally' blocks in cancelled tasks to complete
    const dataTask = yield fork(() => fetchUpdatedData(payload.objectId));
    yield take(cancelExploreDataFetch);
    yield cancel(dataTask);
  })
  yield takeLatest([selectExploreMapPin, setExploreSelectedIds], selectMatchingShape)
}